import React from "react";
export function getNestedValue(obj: any, path: string): any {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}

interface ToggleSwitchProps {
  name?: string;
  label?: string;
  errors?: any;
  register?: any;
  className?: string;
  disabled?: boolean;
  defaultChecked?: boolean;
  showLabel?: boolean;

  // Controlled props
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  name = "",
  label,
  errors,
  register,
  className = "",
  disabled = false,
  defaultChecked = false,
  showLabel = true,
  checked,
  onChange,
}) => {
  const errorMessage = getNestedValue(errors, name)?.message;

  const isControlled = typeof checked === "boolean" && typeof onChange === "function";

  return (
    <div className={`input-container ${className}`}>
      {label && (
        <label htmlFor={name} className="input-label">
          {label}
        </label>
      )}

      <label className="flex items-center gap-2 cursor-pointer select-none">
        {/* {showLabel && (
          <span className="text-xs font-medium text-gray-700">
            {isControlled ? (checked ? "Active" : "Inactive") : defaultChecked ? "Active" : "Inactive"}
          </span>
        )} */}

        <div className="relative w-9 h-5">
          <input
            type="checkbox"
            id={name}
            className="sr-only peer"
            disabled={disabled}
            checked={isControlled ? checked : undefined}
            defaultChecked={!isControlled ? defaultChecked : undefined}
            onChange={isControlled ? (e) => onChange(e.target.checked) : undefined}
            {...(register ? register(name) : {})}
          />
          <div className="w-9 h-5 rounded-full transition-colors duration-300 bg-gray-300 peer-checked:bg-green-500" />
          <div className="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 peer-checked:translate-x-4" />
        </div>
      </label>

      {errorMessage && <p className="input-error-message">{errorMessage}</p>}
    </div>
  );
};

export default ToggleSwitch;
